import gql from 'graphql-tag';

export default gql`
  fragment VehicleOrderItemFragment on OrderItem {
    ... on VehicleOrderItem {
      id
      vehiclePrice: price {
        total {
          amount
          currency
        }
        taxesAndFeesDueAtRentalSite {
          amount
          currency
          __typename
        }
      }
      vehicle {
        category
        code
        type
        description
      }
      vendor {
        name
      }
      promotions {
        id
        code
        headlineDescription
      }
      pickUpDate
      dropOffDate
    }
  }
`;
